'use strict';

class Scroller {
    init () {
        this.scrollTop();

        window.addEventListener('scroll', this.onScroll.bind(this));
        this.onScroll();
    }

    scrollTop () {
        $(document).on('click', '.js-scroll-top', (e) => {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: '0px'
            }, 600);
        });
    }

    update () {
        this.ticking = false;
        if (window.scrollY > 100) {
            $('.js-scroll-top').removeClass('hidden');
        } else {
            $('.js-scroll-top').addClass('hidden');
        }
    }

    onScroll () {
        this.requestTick();
    }

    requestTick () {
        if (!this.ticking) {
            window.raf(this.update.bind(this));
        }
        this.ticking = true;
    }
}

const scroll = new Scroller();
export default scroll;
